import React, { Component } from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';

import PropertyContainer from '../property/PropertyContainer';
import FeaturedContainer from '../featured/FeaturedContainer';
import ThreeDModelContainer from '../threeDModel/ThreeDModelContainer';
import FloorplanFullscreenContainer from '../floorplan/FloorplanFullscreenContainer';
import AgentFullscreenContainer from '../agent/AgentFullscreenContainer';
import GalleryFullscreenContainer from '../gallery/GalleryFullscreenContainer';
import NotProducedComponent from '../notFound/NotProducedComponent';
import NotFoundComponent from '../notFound/NotFoundComponent';
import CanceledComponent from '../notFound/CanceledComponent';
import { isTouchDevice } from '../helpers';
import * as consts from './AppConsts';

import '../assets/shared/_themeTraditional';
import '../assets/shared/_themeCottage';
import '../assets/shared/_themeEstate';
import '../assets/shared/_themeModern';

class AppComponent extends Component {

    componentWillMount () {
        if (window.self != window.top) {
            const touchDevice = isTouchDevice();
            const ref = document.referrer;
            
        	let locationHostnames = window.self.location.hostname;
            
            if (touchDevice 
                // && ref.indexOf(consts.PROD_URL) == -1
                // && ref.indexOf(consts.DEV_URL) == -1
                // && ref.indexOf(consts.LOCAL_URL) == -1
                // && locationHostnames.indexOf(consts.PROD_URL) == -1  
                // && locationHostnames.indexOf(consts.DEV_URL) == -1 
                // && locationHostnames.indexOf(consts.LOCAL_URL) == -1
                ) {
                    // window.top.location = window.self.location;
                    const newWindow = window.open(window.location.href, '_blank');
                
        if (newWindow) {
            // Successfully opened in a new tab; close iframe view
            window.top.location = 'about:blank';
            }
            
            try {
                window.parent.unselectTab(); /* Select "Tour Preview" tab for preview_edit. */
            } catch (parentUnselectTabError) {}
        }
    }
    }

    render() {

        const { blurValue } = this.props;

        return (
            <div
                className="app"
                style={blurValue > 0 ? {filter: `blur(${blurValue}px)`} : {}}>
                <Switch>
                    <Route
                        exact
                        path='/:tourId(\d+)/:tourType(r|u|b|)?'
                        component={PropertyContainer}/>
                    <Route
                        path='/featured/:agentId(\d+)'
                        component={FeaturedContainer}/>
                    <Route
                        path='/:tourId(\d+)/:tourType(r|u|b)/3d'
                        component={ThreeDModelContainer}/>
                    <Route
                        path='/:tourId(\d+)/:tourType(r|u|b)/floorplan'
                        component={FloorplanFullscreenContainer}/>
                    <Route
                        path='/:tourId(\d+)/:tourType(r|u|b)/:agentType(contactagent|contactcolister)'
                        component={AgentFullscreenContainer}/>
                    <Route
                        path='/:tourId(\d+)/:tourType(r|u|b)/gallery'
                        component={GalleryFullscreenContainer}/>
                    <Route path='/notProduced' component={NotProducedComponent}/>
                    <Route path='/notFound' component={NotFoundComponent}/>
                    <Route path='/canceled' component={CanceledComponent}/>
                    <Redirect to='/notFound'/>
                </Switch>
                {this.props.children}
            </div>
        )
    }
}

export default AppComponent;

